import React, { useEffect } from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import am4geodata_Ceuta from './data/spain-ceuta'

const Ceuta = props => {
  const { className, checkedProvinces } = props

  useEffect(() => {
    am4core.useTheme(am4themes_animated)

    let chart = am4core.create('ceuta', am4maps.MapChart)

    try {
      chart.geodata = am4geodata_Ceuta
    } catch (e) {
      chart.raiseCriticalError(new Error('Map geodata could not be loaded.'))
    }

    var selectedHoverColor = '#6551ff60'
    var selectedColor = '#6551ff50'
    var tooltilBackground = '#6551ff'
    var unselectColor = '#ffffff'

    if (checkedProvinces) {
      chart.events.on('ready', function (e) {
        for (var i = 0; i < checkedProvinces.length; i++) {
          selectPolygonById(checkedProvinces[i])
        }
      })
    }

    // Set projection
    chart.projection = new am4maps.projections.Mercator()
    chart.mouseWheelBehavior = 'none'
    chart.seriesContainer.draggable = false
    chart.seriesContainer.resizable = false
    chart.maxZoomLevel = 1
    chart.seriesContainer.events.disableType('doublehit')
    chart.chartContainer.background.events.disableType('doublehit')
    chart.logo.disabled = true
    chart.svgContainer.SVGContainer.style.removeProperty('overflow')

    // Create map polygon series
    var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())

    // Make map load polygon data (state shapes and names) from GeoJSON
    polygonSeries.useGeodata = true

    // Configure series tooltip
    var polygonTemplate = polygonSeries.mapPolygons.template
    polygonTemplate.tooltipText = '{name}'
    polygonTemplate.nonScalingStroke = true
    polygonTemplate.autoTextColor = false
    polygonTemplate.fill = am4core.color(unselectColor)

    // Create hover state and set alternative fill color
    polygonTemplate.events.on('over', function (event) {
      var hitId = event.target.dataItem.dataContext.id
      const fillColor =
        checkedProvinces && checkedProvinces.includes(hitId)
          ? selectedHoverColor
          : selectedColor
      event.target.fill = am4core.color(fillColor)
      event.target.tooltip.getFillFromObject = false
      event.target.tooltip.background.fill = am4core.color(tooltilBackground)
      event.target.tooltip.background.strokeOpacity = 0
      event.target.tooltip.background.cornerRadius = 20
      event.target.tooltip.label.fontSize = 10
    })

    var setColorByValue = function (polygonId) {
      var polygon = getPolygonById(polygonId)

      var color = am4core.color(unselectColor)

      if (polygon.value) {
        color = am4core.color(selectedColor)
      }

      polygon.fill = color
    }

    var getPolygonById = function (polygonId) {
      var polygon = polygonSeries.getPolygonById(polygonId)

      if (!polygon) {
        polygon = {}
      }

      return polygon
    }

    var setValue = function (polygonId, value) {
      var polygon = getPolygonById(polygonId)

      polygon.value = value

      setColorByValue(polygonId)
    }

    polygonTemplate.events.on('out', function (event) {
      setColorByValue(event.target.dataItem.dataContext.id)
    })

    var selectPolygonById = function (polygonId) {
      for (var i = 0; i < polygonSeries.dataItems._values.length; i++) {
        var id = polygonSeries.dataItems._values[i].dataContext.id
        if (polygonId === id) {
          polygonSeries.dataItems._values[i].dataContext.fill = am4core.color(
            '#2673a9',
          )
          setValue(id, 1)
          return
        }
      }
    }
  }, [checkedProvinces])

  return <div id="ceuta" className={className} />
}

export default Ceuta
